import ClassNames from "Helpers/Common";

export const RANGES = [
  { key: "1", label: "24h", text: "last 24h" },
  { key: "3", label: "3d", text: "last 3 days" },
  { key: "7", label: "7d", text: "last 7 days" },
  { key: "30", label: "30d", text: "last 30 days" },
  { key: "90", label: "90d", text: "last 90 days" },
  { key: "all", label: "All", text: "all time" },
];

export const rangeText = (range) => RANGES.find((r) => r.key === range)?.text || "";

export const formatMins = (mins) => {
  if (mins == null) return "—";
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  if (h < 24) return `${h}h ${mins % 60}m`;
  return `${Math.floor(h / 24)}d`;
};

// Seconds-precision duration for fast metrics (e.g. time-to-accept), so
// sub-minute values read as "45s" / "2m 30s" instead of rounding to "0m".
export const formatDuration = (secs) => {
  if (secs == null) return "—";
  if (secs < 60) return `${secs}s`;
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m < 60) return s ? `${m}m ${s}s` : `${m}m`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
};

export const shortDate = (d) => (d ? new Date(d).toLocaleDateString() : "—");

// Compact absolute date + time, e.g. "Sep 1, 3:45 PM". Pinned to en-US +
// hour12 so it always reads as 12-hour AM/PM regardless of the viewer's locale
// (the browser default was rendering 24-hour "15:45" on some machines).
export const dateTime = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return "—";
  return dt.toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true });
};

export const timeAgo = (dateOrMs) => {
  const ts = typeof dateOrMs === "number" ? dateOrMs : new Date(dateOrMs).getTime();
  if (!ts) return "—";
  return `${formatMins(Math.max(0, Math.round((Date.now() - ts) / 60000)))} ago`;
};

export const formatUptime = (seconds) => {
  if (seconds == null) return "—";
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};

// "▲ +3 vs previous period (12)" — shared delta caption for range-windowed stats
export const deltaSub = (current, prev, noun = "") => {
  if (prev === null || prev === undefined) return null;
  const diff = current - prev;
  const arrow = diff > 0 ? "▲" : diff < 0 ? "▼" : "•";
  return `${arrow} ${diff > 0 ? "+" : ""}${diff}${noun} vs previous period (${prev})`;
};

export const Stars = ({ rating }) => (
  <span className={ClassNames("text-sm", rating <= 2 ? "text-red-600" : "text-yellow-500")}>
    {"★".repeat(rating || 0)}
    <span className="text-gray-300">{"★".repeat(Math.max(0, 5 - (rating || 0)))}</span>
  </span>
);
